var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isAvatarMissing)?_c('img',{staticClass:"user-list-img",attrs:{"src":_vm.imageURL},on:{"error":_vm.imageLoadError}}):_c('img',{staticClass:"user-list-img",attrs:{"src":require("@/assets/images/default_user.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }